/** HTML autocomplete token that disables browser autofill on the AddressComplete street field. */
export const ADDRESS_VALIDATION_STREET_BROWSER_AUTOFILL = 'off';

/** HTML autocomplete token that disables browser autofill on other AVS address inputs. */
export const ADDRESS_VALIDATION_FIELD_BROWSER_AUTOFILL = 'disabled';
